import React, { useState, useEffect } from 'react';
import Select from 'react-select';

function HomeEdit() {
    const [categories, setCategories] = useState([]);
    const [selectedCategory, setSelectedCategory] = useState(null);
    const apiBaseUrl = process.env.REACT_APP_API_BASE_URL;
    const cId = "JAPAN_ACCESORIES"; // your DB name / dynamic param

    // Fetch categories for dropdown
    useEffect(() => {
        fetch(`${apiBaseUrl}/getCategories/${cId}`)
            .then((res) => res.json())
            .then((data) => setCategories(data))
            .catch((err) => console.error("Error fetching categories:", err));
    }, [apiBaseUrl]);

    // Fetch previously saved category (if any)
    const fetchSavedCategory = async () => {
        try {
            const res = await fetch(`${apiBaseUrl}/getSavedCategory/${cId}`);
            const data = await res.json();

            if (data && data.CategoryId) {
                setSelectedCategory({
                    value: data.CategoryId,
                    label: categories.find((cat) => cat.Id === data.CategoryId)?.Name || "Saved Category"
                });
            }
        } catch (err) {
            console.error("Error fetching saved category:", err);
        }
    };

    useEffect(() => {
        if (categories.length > 0) {
            fetchSavedCategory();
        }
    }, [categories]);

    // Handle category change and save to DB
    const handleCategoryChange = async (selected) => {
        setSelectedCategory(selected);

        if (selected) {
            try {
                const response = await fetch(`${apiBaseUrl}/saveCategory/${cId}`, {
                    method: "POST",
                    headers: {
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify({ categoryId: selected.value }),
                });

                const result = await response.json();
                if (!result || result.error) {
                    console.error("Failed to save:", result.error);
                } else {
                    console.log("Saved:", result);
                    // 🔄 Refresh after save 
                    fetchSavedCategory();
                    window.location.reload();
                }
            } catch (err) {
                console.error("Error saving category:", err);
            }
        }
    };

    return (
        <div className="max-w-xl mx-auto mt-10 p-6 bg-white shadow-lg rounded-2xl">
            <h1 className="text-2xl font-bold text-center text-indigo-600 mb-6">
                Select a Category
            </h1>

            <Select
                onChange={handleCategoryChange}
                value={selectedCategory}
                isClearable
                isSearchable
                className="react-select-container"
                classNamePrefix="react-select"
                options={categories.map((cat) => ({
                    value: cat.Id,
                    label: cat.Name,
                }))}
            />

            {selectedCategory && (
                <p className="mt-4 text-gray-700">
                    Selected Category: <strong>{selectedCategory.label}</strong> <br />
                    Saved Id: <strong>{selectedCategory.value}</strong>
                </p>
            )}
        </div>
    );
}

export default HomeEdit;
